import CardHeader from '../../../antd/components/CardHeader';
import { TbTrash } from 'react-icons/tb';
import { FiArrowRight } from "react-icons/fi";
import { useEffect, useState } from "react";
import { DeleteHiringAPI, GetAllByCompany} from "../../../API/HiringsAPI";
import { Link, useParams } from "react-router-dom";
import TablePaginationFooter from "../../../Components/Shared/TableDefault/Pagination";
import { FillTable } from "../../../Components/Shared/FillTable";
import { PaginationModel } from "../../../Models/PaginationModel";
import { Button } from "@mui/material";
import Loader from "../../../Components/Shared/Loader";
import { HiringListVOModel, HiringModel } from "../../../Models/HiringModel";
import { CreateHiringsModal } from "../../../Components/Hiring/CreateHiringsModal";
import ModalDelete from '../../../Components/Shared/ModalDelete';
import useModal from "../../../Hooks/useModal";

export default function HiringList () {
    const [ showModal, setShowModal ] = useState(false);
    const { showModal: showModalDelete, toggleShowModal: toggleShowModalDelete } = useModal();
    const [ loading, setLoading ] = useState(false);
    const [ hiringsWithPercentage, setHiringsWithPercentage ] = useState<PaginationModel<HiringModel[]>>();
    const { id } = useParams();
    const [ deleteResponse, setDeleteResponse ] = useState<boolean>(false);
    const [itemToDelete, setItemToDelete] = useState<string>("");

    async function getHirings (page?: number) {
        try {
            setLoading(true);
            await GetAllByCompany(id ?? "", page).then((resp: any) => {
                setHiringsWithPercentage(resp.data);
            });
        }
        catch (error: any) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }
    const handleDelete =  async () => {
        setLoading(true);

        await DeleteHiringAPI(itemToDelete)
        .catch(x => setLoading(false));

        await getHirings()
        .catch(x => setLoading(false));

        setLoading(false);
    }

    useEffect(() => {
        getHirings();
    }, [ id ]);

    useEffect(() => {
        if(deleteResponse){
            handleDelete();
            setDeleteResponse(false);
            setItemToDelete("");
        }
    }, [ deleteResponse ]);
    
    return (
        <>
            {loading && <Loader />}
            <ModalDelete show={showModalDelete} toggleShow={toggleShowModalDelete} setResponse={setDeleteResponse} />
            <CreateHiringsModal
                showModal={showModal}
                setShowModal={setShowModal}
                getHirings={getHirings}
            />
            <div className='card' style={{ marginLeft: '10px', marginRight: '10px' }}>
                <CardHeader
                    pageName={'Cadastro'}
                    hasPageBefore={false}
                />
                <div className='card-body'>
                    <table className='table table-bordered table-striped'>
                        <thead>
                            <tr>
                                <th>Versão</th>
                                <th>Pleito</th>
                                <th>Nome da Contratação</th>
                                <th>Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {hiringsWithPercentage?.items.sort((a, b) => a.version - b.version).map(vo => (
                                <tr key={vo?.id}>
                                    <td>{vo?.version}</td>
                                    <td>{vo?.plea.bankName}</td>
                                    <td>{vo?.name}</td>
                                    <td align="center">
                                        <Link to={`/contract/`}>
                                            <FiArrowRight size={20} className="me-2 cursor-pointer" color="#555555" />
                                        </Link>
                                        <button type="button" className='btn p-0' onClick={() => {setItemToDelete(vo.id); toggleShowModalDelete() }}>
                                            <TbTrash size={20} className="cursor-pointer" />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                                <FillTable columns={4} rows={hiringsWithPercentage?.items.length ?? 0} />
                        </tbody>
                    </table>
                    <div className='d-flex align-items-center justify-content-end'>
                        <TablePaginationFooter
                            totalItems={hiringsWithPercentage?.total ?? 0}
                            change={getHirings}
                        />
                    </div>
                    <Button className="w-100 mt-3" color="primary" variant="contained" onClick={() => setShowModal(true)}> Nova Contratação </Button>
                </div>
            </div>
        </>
    )
}